import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Button from '../common/Button';

const reasons = [
  { id: 'learning', label: 'Learning about ancient wisdom', icon: '📚' },
  { id: 'personal-growth', label: 'Personal growth and self-reflection', icon: '🌱' },
  { id: 'professional', label: 'Professional development', icon: '💼' },
  { id: 'philosophical', label: 'Philosophical interests and discussions', icon: '🧠' },
  { id: 'life-challenges', label: 'Guidance for life challenges', icon: '🛤️' },
  { id: 'curiosity', label: 'General curiosity', icon: '🔍' },
];

const OracleQuestion = ({ onContinue }) => {
  const [selectedReason, setSelectedReason] = useState(null);

  const handleContinue = () => {
    if (selectedReason) {
      onContinue(selectedReason);
    }
  };

  return (
    <motion.div
      className="max-w-2xl mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="text-center mb-12">
        <h2 className="text-3xl font-serif font-bold text-white mb-4">
          The Oracle's First Question
        </h2>
        <p className="text-lg text-white/60">
          What brings you to seek ancient wisdom today?
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {reasons.map((reason, index) => (
          <motion.div
            key={reason.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
          >
            <div
              className={`p-5 rounded-lg cursor-pointer transition-all duration-200 border ${
                selectedReason === reason.id
                  ? 'border-oliveGold bg-oliveGold/10 ring-1 ring-oliveGold/50'
                  : 'border-white/10 bg-white/5 hover:bg-white/8 hover:border-white/20'
              }`}
              onClick={() => setSelectedReason(reason.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setSelectedReason(reason.id)}
            >
              <div className="flex items-center">
                <span className="text-3xl mr-4">{reason.icon}</span>
                <span className={`text-lg ${selectedReason === reason.id ? 'text-oliveGold' : 'text-white/80'}`}>
                  {reason.label}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <Button
          onClick={handleContinue}
          disabled={!selectedReason}
          size="lg"
        >
          Continue
        </Button>
      </div>
    </motion.div>
  );
};

export default OracleQuestion;
